export default () => /Chrome/.test(navigator.userAgent) || /Safari/.test(navigator.userAgent);
